
var React =         require("react");
var ContentServerClient = require("../../ContentServerClient.js");
var ObservableUtil = require("../../util/ObservableUtil.js");
var Loading = require("../modals/Loading.jsx");
var Viewer3D = require("./Viewer3D.jsx");
const {  canUseDOM  } = require('fbjs/lib/ExecutionEnvironment');

class Model3DPreview extends React.Component {

    constructor() {
        super();

        this.state = {loading: true, webgl: true, objPath:false, mtlPath:false}

        this.onSceneLoaded = this.onSceneLoaded.bind(this);
        this.checkWebGL = this.checkWebGL.bind(this);
    }


    componentDidMount() {

        var webgl = this.checkWebGL();

        var assetId = this.props.resource.id;

        var objPath = ContentServerClient.get3DModelPath(assetId, "obj")
        var mtlPath = ContentServerClient.get3DModelPath(assetId, "mtl")

         this.setState({ webgl , objPath, mtlPath});
    }

    checkWebGL(){
        if(!canUseDOM){return false};

        let canvas = document.createElement("canvas");
        let gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        if (gl && gl instanceof WebGLRenderingContext) { return true }
        else { return false }
    }


    onSceneLoaded(error) {
        // TODO error check
        this.setState({loading: false});   
    }

    render() {
        const { loading, webgl, objPath, mtlPath} = this.state;

        return <div className="viewer3d">
            { loading && webgl && 
                <Loading message={"Loading 3D Model"} show={true} showThrobber={true}/>
            }

            {loading && !webgl && 
                <Loading message={"Your browser or device may not support WebGL."} show={true}/>
            }

            {objPath && webgl && <Viewer3D onLoad={this.onSceneLoaded} objPath={objPath} mtlPath={mtlPath} setError={(...params)=>{
              // when we wit a translation error we want the card to reload
                ObservableUtil.callChangeSubscribers("translationError", this.props.resource.id);
                this.props.setError(...params)
              }
            }/>}

        </div>
    }
}

module.exports = Model3DPreview;
